import { createTheme } from "@mui/material/styles";

export function generateTheme(customPalette) {
  let theme = {};
  let paletteObject = {};

  if (!customPalette) {
    paletteObject = defaultPalette;
  } else {
    // Parse the JSON string if needed
    if (typeof customPalette === "string") {
      try {
        paletteObject = JSON.parse(customPalette);
      } catch (error) {
        console.error("Failed to parse customPalette:", error);
        paletteObject = defaultPalette;
      }
    } else {
      paletteObject = customPalette;
    }
  }

  theme = createTheme({ palette: paletteObject });
  theme = defineTypographyStyling(theme);
  theme = defineComponentStyling(theme);
  return theme;
}

let defaultPalette = {
  primary: {
    main: "#72cce1",
    light: "#f1faec",
  },
  secondary: {
    main: "#012d3e",
    light: "#ffffff",
  },
  text: {
    main: "#012d3e",
    light: "#ffffff",
  },
  grey: {
    main: "#d9e3e7",
    light: "#f9f9f9",
    dark: "#9f9e9e",
  },
  action: {
    disabledBackground: "#ebeced !important",
    disabled: "#9f9e9e",
  },
  error: {
    main: "#fc8484",
    light: "#fcf4f4",
  },
};

function defineTypographyStyling(theme) {
  theme.typography.h1 = {
    fontFamily: "Montserrat",
    fontSize: "32px",
    color: theme.palette.primary.main,
    fontWeight: 800,
    [theme.breakpoints.down("sm")]: { fontSize: "24px" },
  };

  theme.typography.h2 = {
    fontFamily: "Montserrat",
    fontSize: "24px",
    color: theme.palette.primary.main,
    fontWeight: "bold",
    [theme.breakpoints.down("sm")]: { fontSize: "18px" },
  };

  theme.typography.h3 = {
    fontFamily: "Montserrat",
    fontSize: "18px",
    color: theme.palette.primary.main,
    fontWeight: "bold",
    [theme.breakpoints.down("sm")]: { fontSize: "16px" },
  };

  theme.typography.p = {
    fontFamily: "Imprima",
    fontSize: "16px",
    color: theme.palette.secondary.main,
    [theme.breakpoints.down("sm")]: { fontSize: "14px" },
  };

  theme.typography.button = {
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontWeight: "bold",
    textTransform: "none",
    [theme.breakpoints.down("sm")]: { fontSize: "12px" },
  };
  return theme;
}

function defineComponentStyling(theme) {
  const styledTheme = createTheme(theme, {
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            display: "flex",
            flexDirection: "column",
            width: "100%",
            height: "100%",
          },
        },
      },
      MuiButton: {
        defaultProps: {
          disableRipple: true,
          disableTouchRipple: true,
        },
        styleOverrides: {
          root: {
            backgroundColor: theme.palette.primary.main,
            border: `2px solid ${theme.palette.primary.main}`,
            borderRadius: "32px",
            color: `${theme.palette.text.light}`,
            padding: "8px 16px",
            "&:hover": {
              backgroundColor: theme.palette.primary.light,
              border: `2px solid ${theme.palette.primary.main}`,
              color: `${theme.palette.primary.main}`,
              "& svg": { color: theme.palette.primary.main },
            },
            "&:disabled": {
              backgroundColor: theme.palette.grey.main,
              border: `2px solid ${theme.palette.grey.main}`,
              color: theme.palette.grey.dark,
              "& svg": { color: theme.palette.grey.dark },
            },
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            "& .MuiOutlinedInput-root": {
              border: "0px",
              height: "35px",
            },
            "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
              border: "0",
              padding: "0px",
            },
            "& .MuiInputBase-input": {
              marginTop: "3px",
              padding: "0px",
              fontSize: "14px",
            },
          },
        },
      },
      MuiChip: {
        styleOverrides: {
          filled: {
            backgroundColor: theme.palette.primary.main,
            "& .MuiChip-label": {
              fontFamily: "Imprima",
              fontSize: "14px",
              color: theme.palette.secondary.light,
            },
            "& .MuiChip-deleteIcon": {
              color: theme.palette.secondary.light,
              "&:hover": {
                color: theme.palette.secondary.main,
              },
            },
          },
        },
      },
    },
  });
  return styledTheme;
}
